import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { templateGalleryMessages } from '@atlaskit/editor-common/messages';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar/toolbar-dropdown-item';
import { ToolbarDropdownItemSection } from '@atlaskit/editor-toolbar/toolbar-dropdown-item-section';
import { ToolbarNestedDropdownMenu } from '@atlaskit/editor-toolbar/toolbar-nested-dropdown-menu';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import SearchIcon from '@atlaskit/icon/core/search';
import TemplateIcon from '@atlaskit/icon-lab/core/template';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { Box } from '@atlaskit/primitives/compiled';

import { openTemplateGallerySafely } from '../../utils/openTemplateGallery';

type Props = {
	onOpenTemplateGallery: () => void;
};

export const TemplateGalleryBlockMenuSection = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<ToolbarDropdownItemSection hasSeparator>{children}</ToolbarDropdownItemSection>
);

export const TemplateGalleryBlockMenuItem = ({
	onOpenTemplateGallery,
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const onClick = useCallback(
		() => openTemplateGallerySafely(onOpenTemplateGallery),
		[onOpenTemplateGallery],
	);

	return (
		<ToolbarNestedDropdownMenu
			text={formatMessage(templateGalleryMessages.blockTemplates)}
			elemBefore={<TemplateIcon label="" size="small" />}
			elemAfter={<ChevronRightIcon label="" size="small" />}
			elemAfterText={
				<Box as="span" paddingInlineStart="space.075">
					<Lozenge appearance="new">{formatMessage(templateGalleryMessages.newLozenge)}</Lozenge>
				</Box>
			}
			shouldTitleWrap={false}
		>
			<ToolbarDropdownItemSection>
				<ToolbarDropdownItem elemBefore={<SearchIcon label="" size="small" />} onClick={onClick}>
					{formatMessage(templateGalleryMessages.browseTemplates)}
				</ToolbarDropdownItem>
			</ToolbarDropdownItemSection>
		</ToolbarNestedDropdownMenu>
	);
};
